// extracted by mini-css-extract-plugin
export default {"logoPlaceholder":"BusinessLogoUploadSettingItem_logoPlaceholder__m0jNe"};